import { useI18n } from '../i18n.jsx';

function DateFilterBar({ filter, onChange, style: containerStyle }) {
  const { t } = useI18n();
  const dateInputStyle = { padding: '5px 8px', fontSize: '0.78rem', border: '1px solid var(--border-color)', borderRadius: '6px', background: 'var(--bg-tertiary)', color: 'var(--text-primary)', width: '130px' };
  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap', ...containerStyle }}>
      <select
        value={filter.mode}
        onChange={e => onChange({ ...filter, mode: e.target.value, from: '', to: '' })}
        style={{ padding: '5px 8px', fontSize: '0.78rem', border: '1px solid var(--border-color)', borderRadius: '6px', background: 'var(--bg-tertiary)', color: 'var(--text-primary)', cursor: 'pointer' }}
      >
        <option value="all">{t('filterAll')}</option>
        <option value="daily">{t('filterDaily')}</option>
        <option value="weekly">{t('filterWeekly')}</option>
        <option value="monthly">{t('filterMonthly')}</option>
        <option value="yearly">{t('filterYearly')}</option>
        <option value="custom">{t('filterCustom')}</option>
      </select>
      {filter.mode === 'custom' && (
        <>
          <input type="date" value={filter.from || ''} onChange={e => onChange({ ...filter, from: e.target.value, mode: 'custom' })} style={dateInputStyle} />
          <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>—</span>
          <input type="date" value={filter.to || ''} onChange={e => onChange({ ...filter, to: e.target.value, mode: 'custom' })} style={dateInputStyle} />
        </>
      )}
    </div>
  );
}

export default DateFilterBar;
